import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { ConfigurationComprobanteDataSource } from './configurationComprobantes.datasource';
import { CComprobanteData } from '../Model/ccomprobante.model';
import { DatosDocumento } from '../Model/datosDocumento.model';

@Injectable({
  providedIn: 'root'
})

export class ComprobanteService {

  constructor(private http: HttpClient) { }

  obtenerCaptcha(): Observable<string>{
    console.log(ConfigurationComprobanteDataSource.getInstance().baseUrl +`api/Comprobantes/generar-captcha/`)
    return this.http.get<string>(ConfigurationComprobanteDataSource.getInstance().baseUrl +`api/Comprobantes/generar-captcha/`,
    {
      headers: ConfigurationComprobanteDataSource.getInstance().getConfHeaders(),
      responseType: 'text' as 'json'
    });
  }

  consultarComprobante(data: CComprobanteData): Observable<any>{
    return this.http.post<any>(ConfigurationComprobanteDataSource.getInstance().baseUrl +`api/Comprobantes/consulta-pdf/`, data,
    {headers: ConfigurationComprobanteDataSource.getInstance().getConfHeaders()});
  }

  enviarWhatsapp(data: DatosDocumento): Observable<any>{
    return this.http.post<any>(ConfigurationComprobanteDataSource.getInstance().baseUrl +`api/Comprobantes/envio-whatsapp/`, data,
    {headers: ConfigurationComprobanteDataSource.getInstance().getConfHeaders()});
  }

  existeId(id: string): Observable<any> {
    return this.http.get<any>(ConfigurationComprobanteDataSource.getInstance().baseUrl +`api/Comprobantes/existe-id/${id}`,
    {headers: ConfigurationComprobanteDataSource.getInstance().getConfHeaders()});
  }

  consultaDocs(data: CComprobanteData): Observable<any> {
    return this.http.post<any>(ConfigurationComprobanteDataSource.getInstance().baseUrl +`api/Comprobantes/consulta-docs/`, data,
    {headers: ConfigurationComprobanteDataSource.getInstance().getConfHeaders()});
  }


}
